import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback, useContext, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { EditCellContext } from 'src/contexts/EditCellContext';
import { stopPropagation } from 'src/utils';

const SpentOrHoldBalance: FC<GridCellProps> = (props) => {
  const [cellClick] = useContext(EditCellContext);
  const { dataItem, field = '' } = props;
  const { displayValue } = useGridCellDisplayValue(props);
  const handleClick = useCallback(
    (e: any) => {
      stopPropagation(e);
      cellClick?.({
        data: props.dataItem,
        type: field === 'spentAmount' ? 'actualizedAmount' : field,
      });
    },
    [cellClick, field, props.dataItem]
  );

  const hasTransactionData = useMemo(
    () =>
      field === 'spentAmount' ? dataItem.hasSpentTransactionData : dataItem.hasHoldTransactionData,
    [dataItem.hasHoldTransactionData, dataItem.hasSpentTransactionData, field]
  );

  const button = (
    <button onClick={handleClick} className="text-link cursor-pointer border-b border-b-blue-500">
      {displayValue}
    </button>
  );

  return (
    <GridCellBase {...props} className="!text-right" title={displayValue} rowSelectionEnabled>
      {field === 'spentAmount'
        ? hasTransactionData
          ? button
          : displayValue
        : hasTransactionData
        ? button
        : displayValue}
    </GridCellBase>
  );
};

export default SpentOrHoldBalance;
